import React from 'react';
import styled from 'styled-components';
import { StyledButton as Button } from '../../../CommonComponents/Button';
import Icon from '../../../CommonComponents/Icon';
import { ellipsis } from 'polished';

export const ListItem = props => (
  <li
    onMouseDown={event => {
      event.preventDefault();
      event.stopPropagation();
    }}
    {...props}
  />
);

export const UserInformation = styled.div`
  border-right: 1px solid rgba(151, 151, 151, 0.5);
  height: 100%;
  padding: 0;
  width: 305px;
  text-align: center;
  position: relative;
`;

export const ClientMenuButton = styled(Button.Link).attrs({
  appendIcon: 'fas fa-caret-down',
})`
  display: flex;
  align-items: center;
  padding: 0 40px 0 0px;
  width: 100%;
  text-align: left;
  color: rgb(68, 68, 68);
  word-break: break-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100%;

  ${Button.ChildrenWrapper} {
    width: 100%;
  }

  ${Button.AppendedIcon} {
    font-size: 1em;
    margin-left: 8px;
    color: rgb(93, 87, 87);
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const Name = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 1.3em;
  margin-top: -0.15em;
  ${ellipsis()}
`;

export const OnlineIcon = styled(Icon).attrs({
  className: 'fas fa-circle',
})`
  vertical-align: middle;
  font-size: 8px;
  color: ${props => (props.online ? '#39AC67' : '#ddd')};
  margin-right: 8px;
`;

export const ClientOnlineStatus = styled.div`
  display: block;
  font-size: 14px;
`;
